import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useTranslation } from 'react-i18next';
import {
  AddNtxPeoples,
  cleanPeoplesById,
  GetNtxPeoplesByID,
  GetNtxPeoplesList,
  UpdatNtxPeoples
} from '@store/NTX/Peoples/peoplesSlice';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import useGetFormColumn from '@hooks/Forms/use-get-FColumn';
// import ExtraInformationBuilderAdd from '@pages/ExtraInformation/ExtraInformationBuilder/Add/ExtraInformationBuilderAdd';
import { useEffect, useState } from 'react';
import useAddUpdateExtraInformation from '@pages/ExtraInformation/ExtraInformationBuilder/useAddUpdateExtraInformation';
// import ExtraInformationBuilderUpdate from '@pages/ExtraInformation/ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';
import Loading from '@components/Shared/Loader/Loading';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

type Props = {
  Id?: string | null;
  isUpdate?: boolean;
};

const AddUpdateTenants: React.FC<Props> = ({ Id, isUpdate = false }) => {
  const { HasPermission } = usePermissions();
  const [extraInfoFormData, setExtraInfoFormData] = useState<any>({});

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();

  useEffect(() => {
    if (Id && isUpdate) {
      dispatch(GetNtxPeoplesByID(Id));
    }

    return () => {
      dispatch(cleanPeoplesById());
    };
  }, [Id, dispatch, isUpdate]);

  const { PeoplesById, loading: loading, error } = useAppSelector(state => state.Peoples);

  const formik = useFormik({
    initialValues: {
      id: PeoplesById?.id ?? null,
      name: PeoplesById?.name ?? '',
      name2: PeoplesById?.name2 ?? '',
      typeCode: 'Tenants',
      email: PeoplesById?.email ?? '',
      phone: PeoplesById?.phone ?? '',
      mobile: PeoplesById?.mobile ?? '',
      address: PeoplesById?.address ?? '',
      extraInformationId: PeoplesById?.extraInformationId ?? null
    },
    enableReinitialize: true,

    onSubmit: async values => {
      // بناء الـ request body
      const requestBody: any = {
        id: values.id,
        name: values.name,
        name2: values.name2,
        // personId: values.personId || null,
        personId: null,
        email: values.email,
        phone: values.phone,
        mobile: values.mobile,
        address: values.address,
        typeCode: values.typeCode,
        customerNumber: '',
        parentId: null,
        extraInformationId: null, // سيتم تحديثه لاحقًا
        priceListId: null,
        shipToLocationId: null,
        billToLocationId: null,
        termsId: null,
        setOfBooksId: null,
        creditLimit: 0,
        paymentPriority: null,
        invoiceCurrencyCode: null,
        paymentCurrencyCode: null,
        invoiceLimit: null,
        paymentMethodLookupCode: '',
        bankAccountName: '',
        bankAccountNum: '',
        bankNumber: '',
        bankAccountType: '',
        vatCode: 0,
        tradingName: '',
        workReference: '',
        companyRegistrationNumber: '',
        nationalInsuranceNumber: '',
        verificationNumber: '',
        description: '',
        peopleType: ''
      };

      // let finalExtraInformationId = values.extraInformationId;

      // // فقط إذا لم يكن موجودًا أو نحتاج لإنشاء واحد جديد
      // // if (!isUpdate || (isUpdate && values.extraInformationId === null)) {
      // if (values.extraInformationId === null) {
      //   if (FormColumnList?.columnList?.length > 0) {
      //     const newExtraInfoId = await AddUpdateExtraInformation(extraInfoFormData);
      //     if (newExtraInfoId === null) {
      //       CustomAlert({ action: 'Error', msg: 'حدث خطأ' });
      //       formik.setSubmitting(false);
      //       return;
      //     }
      //     finalExtraInformationId = newExtraInfoId;
      //   }
      // } else {
      //   // حالة التحديث مع وجود extraInfo
      //   if (extraInfoFormData?.values?.length > 0) {
      //     const updatedExtraInfoId = await AddUpdateExtraInformation(extraInfoFormData);
      //     if (updatedExtraInfoId === null) {
      //       CustomAlert({ action: 'Error', msg: 'فشل في تحديث المعلومات الإضافية' });
      //       formik.setSubmitting(false);
      //       return;
      //     }
      //     finalExtraInformationId = updatedExtraInfoId;
      //   }
      // }

      // // دمج الـ extraInformationId في الطلب
      // requestBody.extraInformationId = finalExtraInformationId;

      // تحديد الإجراء (إضافة أو تعديل)
      const actionToDispatch = isUpdate ? UpdatNtxPeoples(requestBody) : AddNtxPeoples(requestBody);

      // تنفيذ الإجراء
      dispatch(actionToDispatch)
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            if (isUpdate) {
              CustomAlert({ action: 'Edit' });
            } else {
              // document.getElementById('closeModalForm')?.click();
              formik.resetForm();
              CustomAlert({ action: 'Add' });
            }
            dispatch(GetNtxPeoplesList('OWNERS'));
          } else {
            CustomAlert({ action: 'Error', msg: res?.message || 'حدث خطأ غير معروف' });
          }
        })
        .catch(error => {
          console.error('Error in dispatch:', error);
          CustomAlert({ action: 'Error', msg: 'خطأ في الاتصال أو المعالجة' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  // const {
  //   FormColumnList,
  //   loading: loading2,
  //   error: error2
  // } = useGetFormColumn(
  //   !isUpdate || (isUpdate && formik.values.extraInformationId === null)
  //     ? 'c0954c95-9ad3-47e7-8994-2f3179f02388'
  //     : undefined
  // );

  return (
    <>
      <Loading loading={loading || loading} error={error || error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='mb-4'>
            <>
              <div className='row'>
                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('LocalName')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='name2'
                      onChange={formik.handleChange}
                      value={formik.values.name2}
                      isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('GlobalName')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='name'
                      onChange={formik.handleChange}
                      value={formik.values.name}
                      isInvalid={!!(formik.touched.name && formik.errors.name)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                  </div>
                </div>

                {/* <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('EmployeeName')}</label>
                    <Select
                      classNamePrefix='react-select'
                      isLoading={personLoading}
                      isSearchable={true}
                      isClearable
                      name='personId'
                      options={dataEmployees}
                      onChange={option => {
                        formik.setFieldValue('personId', option === null ? null : option.value);
                      }}
                      value={
                        formik.values.personId
                          ? dataEmployees?.find((option: any) => option.value === formik.values.personId)
                          : null
                      }
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />

                    {formik.errors.personId && formik.touched.personId && (
                      <div style={{ color: 'red' }}>{formik.errors.personId}</div>
                    )}
                  </div>
                </div> */}
              </div>

              <div className='row'>
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Email')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='email'
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      isInvalid={!!(formik.touched.email && formik.errors.email)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('MobileNumber')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='mobile'
                      onChange={formik.handleChange}
                      value={formik.values.mobile}
                      isInvalid={!!(formik.touched.mobile && formik.errors.mobile)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.mobile}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Address')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='address'
                      onChange={formik.handleChange}
                      value={formik.values.address}
                      isInvalid={!!(formik.touched.address && formik.errors.address)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.address}</Form.Control.Feedback>
                  </div>
                </div>
              </div>
            </>
          </div>

          {/* <div className='rounded-2 p-3 mb-3 border border-theme'>
            <div className='d-flex align-items-center mb-3'>
              <i className='fa fa-info-circle fa-lg text-theme me-2'></i>
              <h5 className='mb-0'>{t('ExtraInformation')}</h5>
            </div>

            {formik.values.extraInformationId === null && (
              <ExtraInformationBuilderAdd
                FormColumnList={FormColumnList}
                setExtraInfoFormData={setExtraInfoFormData}
                ReferenceId={formik.values.id}
              />
            )}

            {formik.values.extraInformationId !== null && (
              <ExtraInformationBuilderUpdate
                extraInformationId={formik.values.extraInformationId}
                referenceId={formik.values.id}
                setExtraInfoFormData={setExtraInfoFormData}
              />
            )}
          </div> */}

          <div className='text-center'>
            <div className='d-flex justify-content-between gap-2'>
              <button
                hidden={!HasPermission('FleetEditOwner')}
                disabled={formik.isSubmitting}
                type='submit'
                className='btn btn-lg btn-theme mb-1 w-100'
              >
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-save fa-lg fa-fw me-2'></i>
                )}
                {t('Save')}
              </button>
              <button type='button' className='btn btn-lg  btn-default mb-1 w-100' data-bs-dismiss='modal'>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default AddUpdateTenants;
